import axios from 'axios'
import { isFunction as _isFunction } from 'lodash'
import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const GetVdayOffers = async (
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    const data = {
        'queryOptions': {
            'filter': '',
            'pagination': {
                'count': 0,
                'limit': 20,
            },
            'sorting': '',
        },
        'queries': [
            {
                'query': `$.redeemerId=${msisdn}`,
            },
            {
                'operator': 'AND',
            },
            {
                'query': '$.type=reward',
            },
            {
                'operator': 'AND',
            },
            {
                'query': '$.channelId=selfcare',
            },
            {
                'operator': 'AND',
            },
            {
                'query': '$.category=category',
            },
            {
                'operator': 'AND',
            },
            {
                'query': '$.id=all',
            },
        ],
    }

    onStart()

    try {
        const response = await axios.post(API_URLS.getOffersVday, data, {
            headers: customHeaders,
            data: null,
        })

        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

export default GetVdayOffers
